import { IFileDataBase64 } from "../../interface/fileDataBase64.interface";

export const initFileData: IFileDataBase64 = {
    content: '',
    name: '',
    size: 0,
    contentType: '-1'
}